import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    InvoiceDesignation,
} from 'app/enums/label.enums'

import {
    LongTermLeaseInvoicesCreateForm,
} from '../../longTermLease.types'

const getFields = ({
    getAllowedValues,
    pricingCurrencyAllowedValues,
    pricingAccount,
    customerExecution,
}: {
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
    pricingCurrencyAllowedValues: Record<string, string>,
    pricingAccount: {id: number},
    customerExecution: {id: number},
}): DTOCardFormField<keyof LongTermLeaseInvoicesCreateForm>[] => {
    return [{
        title: 'CREATE_NEW_INVOICE',
        fields: [
            {
                id: 'create-invoice-column1',
                fields: [
                    {
                        name: 'invoiceDesignation',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceDesignation),
                        required: true,
                        labelKey: 'INVOICE_DESIGNATION',
                    },
                    {
                        name: 'longTermLeaseFees',
                        componentName: 'ObjectSelect',
                        allowedValues: pricingCurrencyAllowedValues,
                        required: true,
                        noNone: true,
                        labelKey: 'CURRENCY',
                    },
                ],
            },
            {
                id: 'create-invoice-column2',
                fields: [
                    {
                        name: 'pricingAccount',
                        componentName: 'AccountSelector',
                        value: pricingAccount,
                        disabled: true,
                        labelKey: 'PRICING_ACCOUNT',
                    },
                    {
                        name: 'customerExecution',
                        componentName: 'LocationObjectSelector',
                        value: customerExecution,
                        disabled: true,
                        labelKey: 'CUSTOMER_QUOTATION',
                    },
                ],
            },
        ],
    }]
}

export default getFields
